<template>
  <div class="bigBox">
    <!-- <div class="topStyle">
      <div class="iconStyle" @click="back">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="typeTitle">人员登记</div>
    </div> -->
    <div class="searchBox">
      <el-form :model="dataFrom" ref="dataFrom" :rules="rules" label-width="110px">
        <el-form-item label="姓名:" prop="applyUname">
          <el-input v-model.trim="dataFrom.applyUname" maxlength="10" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="mobile">
          <el-input v-model.trim="dataFrom.mobile" maxlength="11" v-number-input.float="0" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="来访时间:" prop="visitTime">
          <!-- format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm" -->
          <el-date-picker
            v-model="dataFrom.visitTime"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="来访部门:" prop="visitDepmetcode">
          <el-select v-model="dataFrom.visitDepmetcode" @change="selectChange" placeholder="请选择来访部门">
            <el-option v-for="item in visitDepmetList" :label="item.name" :key="item.id"
              :value="item.code" :style="{ fontSize: 17 + 'px' }"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="来访事由:">
          <el-input type="textarea" maxlength="50" v-model.trim="dataFrom.visitDesc" style="width:230px;" :rows="3"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="btnBox">
      <el-button class="btnStyle" type="primary" @click="saveFn('dataFrom')">提 交</el-button>
    </div>
  </div>
</template>
<script>
import { visitauditAdd,getDepartmentByTenantCode } from '@/api/vgs-driver'
export default {
  name: 'personnelNoLogin',
  data () {
    return {
      dataFrom:{
        applyType:'1',
        visitTime:'',
        tenantCode:this.$route.query.tenantCode,
        tenantName:this.$route.query.tenantName
      },
      visitDepmetList:[],
      rules: {
        applyUname: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          this.rule.mobile
        ],
        visitTime: [
          { required: true, message: '请输入来访时间', trigger: 'blur' }
        ],
        visitDepmetcode: [
          { required: true, message: '请输入来访部门', trigger: 'blur' }
        ],
      },
    }
  },
  created () {
    document.title = '人员登记';
    const newdateTime = new Date().getTime()
    this.dataFrom.visitTime = this.dateFormat(newdateTime)
    console.log(this.dataFrom.visitTime,'2222')
    console.log(this.dataFrom.tenantCode,'this.tenantCode')
    console.log(this.dataFrom.tenantName,'this.tenantName')
    this.getDepartmentByTenantCode()
  },
  methods: {
    // 获取部门
    getDepartmentByTenantCode(){
      getDepartmentByTenantCode({
        tenantCode:this.dataFrom.tenantCode
      }).then(res => {
        console.log(res,'res')
        this.visitDepmetList = res
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    selectChange(val){
      console.log(val,'val')
      this.visitDepmetList.forEach(item=>{
        if(item.code == val){
          this.$set(this.dataFrom,'visitDepmetname',item.name)
        }
      })
    },
    saveFn(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.dataFrom,'this.dataFrom')
          let imgfile = new FormData()
          this.dataFrom.visitTime = this.dateFormat(this.dataFrom.visitTime)
          imgfile.set('params', JSON.stringify(this.dataFrom))
          console.log(imgfile,'imgfile')
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          visitauditAdd(imgfile).then(res => {
            loading.close()
            this.$message({
              message: '登记成功',
              type: 'success'
            })
            this.back()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    dateFormat(timestamp) {
      let date = new Date(timestamp);    //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-';
      let M = ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) :
              (date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s;
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  },
}
</script>
<style scoped lang='less'>
.bigBox{
  width: 100vm;
  height: 100vh;
  background-color: #fff;
  overflow: hidden;
}
.topStyle{
  display: flex;
  margin-top: 30px;
}
.iconStyle{
  position: absolute;
  left: 20px;
  font-size: 20px;
  font-weight: bold;
}
.typeTitle{
  margin: 0 auto;
  font-weight: 700;
}
.searchBox{
  width: 100%;
  margin: 40px auto;
}
.btnBox{
  width: 80%;
  margin-left: 10%;
  margin-top: 60px;
}
.btnStyle{
  width: 100%;
  border-radius: 20px;
  font-size: 20px;
}
/deep/.el-input .el-input__inner{
  width: 230px !important;
  font-size: 17px;
}
/deep/.el-form-item__label{
  font-size: 17px;
}
</style>